(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[874],{

/***/ 6569:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides",
      function () {
        return __webpack_require__(5586);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Guides; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_layout_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7272);
/* harmony import */ var _styles_layout_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_layout_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _styles_guides_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1775);
/* harmony import */ var _styles_guides_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_guides_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(682);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3562);
/* harmony import */ var _src_util_src_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4873);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);








var __N_SSG = true;
function Guides(props) {
    // const { } = props
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(translationNamespaces).t;
    var tc = (0,_src_util_src_i18next__WEBPACK_IMPORTED_MODULE_4__/* .withNamespace */ .Q)(t, "common");
    var tPages = (0,_src_util_src_i18next__WEBPACK_IMPORTED_MODULE_4__/* .withNamespace */ .Q)(t, "pages");
    var title = t("title");
    var description = t("description");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: (_styles_layout_module_css__WEBPACK_IMPORTED_MODULE_6___default().main),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: (_styles_guides_module_css__WEBPACK_IMPORTED_MODULE_7___default().instructionHeader),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_guides_module_css__WEBPACK_IMPORTED_MODULE_7___default().instructionSubheader),
                children: t("defi")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/defi/make-money-on-BUSD-via-AlpacaFinance",
                        children: tPages("defi.make-money-on-BUSD-via-AlpacaFinance.title")
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_guides_module_css__WEBPACK_IMPORTED_MODULE_7___default().instructionSubheader),
                children: t("p2e")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/play-to-earn/games",
                        children: tPages("play-to-earn.overview.title")
                    })
                })
            })
        ]
    });
};
var translationNamespaces = [
    "guides",
    "pages",
    "common"
];


/***/ }),

/***/ 4873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ withNamespace; }
/* harmony export */ });
function withNamespace(t, ns) {
    return function(key) {
        return t(key, {
            ns: ns
        });
    };
}


/***/ }),

/***/ 1775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"instruction-header":"guides_instruction-header__FBi6Z","instruction-subheader":"guides_instruction-subheader__9Md2b"};

/***/ }),

/***/ 7272:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__5R52X","hero":"layout_hero__sdPiy","main":"layout_main__j5lor","footer":"layout_footer__a_vOy","title":"layout_title__zDlUa","subtitle":"layout_subtitle__Wt4qK","code":"layout_code__EMwy8","grid":"layout_grid__gVdal","card":"layout_card__dnilS","logo":"layout_logo__ZuUu7","list":"layout_list__0_v1E"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,774,888,179], function() { return __webpack_exec__(6569); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);